import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl, defaultAddErrorMessage, errorTranslate } from "./util";

export const updateService = ({
  id,
  name,
  input,
  qty,
  unit,
  supply,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    name: name,
    components: [],
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/product/" + id,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        confirmButtonColor: "#a9c1b4",
        color: "#476355",
        background: "#f1f8ef",
      });
      setErrorMessage();
    })
    .catch(function (error) {
      setErrorMessage(error.response.data);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: defaultAddErrorMessage,
        confirmButtonColor: "#a9c1b4",
        color: "#476355",
        background: "#f1f8ef",
      });
      console.log(error);
    });
};

export const createService = ({
  name,
  input,
  qty,
  unit,
  supply,
  setStatus = function () {
    return;
  },
  setErrorMessage = function () {
    return;
  },
  setIdBusiness = function () {
    return;
  },
}) => {
  // // console.log()
  // setSaving(true)
  var data = JSON.stringify({
    name: name,
    is_product: false,
    components: [],
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/product/add",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      // setSaving(false)
      setStatus(true);
      setIdBusiness(response.data.data.productID);

      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      // Swal.fire(
      //   "Error!",
      //   error,
      //   "error"
      // );
      setErrorMessage(error.response.data);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: defaultAddErrorMessage,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      // setSaving(false)
    });
};

export const getServiceList = ({ setProducts, setShared }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/product/list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  axios(config)
    .then(function (response) {
      setProducts(
        response.data.data.filter((prod) => prod.is_product === false)
      );
      setShared(
        response.data.shared.filter((prod) => prod.is_product === false)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getServiceDetail = ({
  id,
  setName = function () {
    return;
  },
  setCreatedAt = function () {
    return;
  },
  setIsProduct = function () {
    return;
  },
  setRecycled = function () {
    return;
  },
  setLandfill = function () {
    return;
  },
  setBurnt = function () {
    return;
  },
  setComponents = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/product/" + id + "/detail",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data)
      setName(response.data.data.product.name);
      setRecycled(response.data.data.product.recycled);
      setLandfill(response.data.data.product.landfill);
      setBurnt(response.data.data.product.burnt);
      setCreatedAt(response.data.data.product.created_at);
      setIsProduct(response.data.data.product.is_product);
      setComponents(
        response.data.data.components.map((comp) => {
          comp.physical_unit = comp.category.physical_unit;
          return comp;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteService = ({ id }) => {
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/product/" + id,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    })
    .catch(function (error) {
      console.log(error);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};
